import { Box, HStack, Text, VStack } from "@chakra-ui/react"
import Dialog from "@hydrologiq/shared/chakra/Dialog"
import { ActionButton } from "@hydrologiq/shared/content/components/Button"

interface RemoveSystemDialogProps {
  open: boolean
  systemName: string
  onConfirm: () => void
  onClose: () => void
  loading?: boolean
}

const bullets = [
  "All settings associated with this system will be deleted",
  "Data connections and monitoring configurations will be removed",
  "This action cannot be undone",
]

export function RemoveSystemDialog({
  open,
  systemName,
  onConfirm,
  onClose,
  loading = false,
}: RemoveSystemDialogProps) {
  return (
    <Dialog
      title="Remove System"
      open={open}
      setOpen={(isOpen) => {
        if (!isOpen) onClose()
      }}
      onClose={onClose}
      footer={
        <HStack gap={3}>
          <ActionButton
            onClick={onClose}
            disabled={loading}
            context={{
              label: "Cancel",
              description: "Cancel removal",
              variant: "secondary",
            }}
          />
          <ActionButton
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
            context={{
              label: "Remove system",
              description: "Permanently remove this system",
              variant: "warning",
            }}
          />
        </HStack>
      }
    >
      <VStack align="stretch" gap={3}>
        <Box borderWidth="1px" borderRadius="md" p={3} bg="bg.subtle">
          <Text fontWeight="semibold" fontSize="sm">{systemName}</Text>
        </Box>
        <Text>Removing this system will:</Text>
        <Box as="ul" pl={5} listStyleType="disc">
          {bullets.map((item) => (
            <Box as="li" key={item}>{item}</Box>
          ))}
        </Box>
        <Text fontSize="sm" color="fg.muted">
          <Text as="span" fontWeight="semibold">Note:</Text> Historical monitoring data for assets previously assigned to this system will not be affected.
        </Text>
      </VStack>
    </Dialog>
  )
}

export default RemoveSystemDialog
